import { useRef, useState, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import { HiOutlineMoon, HiOutlineSun, HiOutlineBars3CenterLeft } from "react-icons/hi2";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "../redux/slices/themeSlice";
import defaultAvatar from '../assets/smart_mentor.png';
import { logout } from '../service/authService';

const DashboardNavbar = ({ user, toggleSidebar }) => {
  const dispatch = useDispatch();
  const { theme } = useSelector((state) => state.theme);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    dispatch(setTheme(newTheme));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className={`sticky top-0 z-[38] flex items-center justify-between px-4 sm:px-6 py-2.5 mx-4 sm:mx-6 mb-4 mt-4 sm:mt-4 rounded-xl shadow-md sm:shadow-lg transition-colors duration-300 ${
      theme === 'dark' ? 'bg-[#2f3349] sm:bg-[#2f3349]/80 sm:backdrop-blur-md border-b border-gray-700 sm:border-none' : 'bg-white sm:bg-white/80 sm:backdrop-blur-md border-b border-gray-100 sm:border-none'
    }`}>
      <div className="flex items-center">
        <button
          onClick={toggleSidebar}
          className="lg:hidden p-2 mr-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
        >
          <HiOutlineBars3CenterLeft size={24} className={theme === 'dark' ? 'text-[#cfd3ec]' : 'text-gray-600'} />
        </button>
        <h4 className={`text-sm sm:text-lg font-semibold truncate max-w-[150px] sm:max-w-none ${theme === 'dark' ? 'text-[#cfd3ec]' : 'text-gray-800'}`}>
          Welcome back, {user?.first_name || "User"}! 👋
        </h4>
      </div>

      <div className="flex items-center space-x-3">
        <button 
          onClick={toggleTheme} 
          className={`p-2 rounded-full transition-colors duration-200 ${
            theme === 'dark' 
              ? 'hover:bg-gray-700 text-yellow-300' 
              : 'hover:bg-gray-100 text-gray-700'
          }`}
        >
          {theme === 'dark' ? <HiOutlineSun size={24} /> : <HiOutlineMoon size={24} />}
        </button>

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center focus:outline-none"
          >
            <div className="relative">
              <img
                src={user?.dp || defaultAvatar}
                alt="Profile"
                className="w-10 h-10 rounded-full object-cover border-2 border-indigo-600 ring-2 ring-indigo-600/20 shadow-inner"
              />
              <span className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 border-2 border-white dark:border-gray-800 rounded-full"></span>
            </div>
          </button>

          {dropdownOpen && (
            <div className={`absolute right-0 mt-3 w-48 rounded-lg shadow-xl py-1 z-50 border ${
              theme === 'dark' 
                ? 'bg-[#2f3349] border-gray-700 text-[#cfd3ec]' 
                : 'bg-white border-gray-100 text-gray-700'
            }`}>
              <div className="px-4 py-3 border-b dark:border-gray-700">
                <p className="text-sm font-semibold">{user?.first_name} {user?.last_name}</p>
                <p className="text-xs text-gray-400 truncate">{user?.email}</p>
              </div>
              <Link
                to="/profile"
                className={`block px-4 py-2 text-sm transition-colors duration-200 ${
                  theme === 'dark' ? 'hover:bg-gray-700' : 'hover:bg-indigo-50 hover:text-indigo-600'
                }`}
                onClick={() => setDropdownOpen(false)}
              >
                My Profile
              </Link>
              <button
                onClick={logout}
                className={`w-full text-left px-4 py-2 text-sm transition-colors duration-200 ${
                  theme === 'dark' ? 'hover:bg-gray-700' : 'hover:bg-indigo-50 hover:text-indigo-600'
                }`}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default DashboardNavbar;
